/** @format */

import React, { useState, useEffect, useContext } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useHistory } from "react-router-dom";
import paginationFactory from "react-bootstrap-table2-paginator";
import { payOptionService } from "../../Services/payoption.service";
import ListAdminButtons from "../Common/ListAdminButtons";
import ResultModal from "../Common/ResultModal";
import { useTranslation } from "react-i18next";
import DeleteModal from "../PayOption/DeleteModal";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import SpinnerLoading from "../Common/SpinnerLoading";
import { AuthContext } from "../../Contexts/AuthContext";
import { roles } from "../../Config/Roles";
import Tooltip from "../Common/Tooltip";

const Index = () => {
  const { t: translator } = useTranslation();
  const { updateLocTab, updateLocName, isMobile } = useContext(GlobalContext);
  const { roleId } = useContext(AuthContext);
  const { master, admin } = roles;
  const [payOptions, setPayOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });
  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
  });
  const [update, setUpdate] = useState(new Date());
  const [selectedItems, setSelectedItems] = useState([]);
  const [searchName, setSearchName] = useState("");
  const history = useHistory();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    updateLocName("instructions");
    updateLocTab(0);
  }, [update, searchName]);

  const AddPayOption = () => {
    history.push("/add-pay-methods");
  };

  return (
    <div className="p-2 pt-3">
      <div className="card container-fluid p-0">
        <div className="card-header card-wrap">
          <span>{translator("Instructions-View-Subtitle")}</span>
        </div>
        <div className="card-body">
          <ul>
           
            
            <li>
              <a
                href="/Priručnik za korištenje Premium fiskalne blagajne_verzija 3.2.0.pdf"
                target="_blank"
              >
                Upute za korištenje blagajničke aplikacije
              </a>
            </li>
            <li>
              <a
                href="/Premium Fiskalna blagajna - korisnička uputstva.pdf"
                target="_blank"
              >
                Upute za korištenje web portala
              </a>
            </li>
           
            <li>
              <a
                href="/Priručnik za korištenje Robnog knjigovodstva.pdf"
                target="_blank"
              >
                Upute za korištenje korištenje modula robno
              </a>
            </li>
          
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Index;
